import React, { FunctionComponent, useRef } from 'react';

import { InputProps } from '@gojob/ui-bits/Input';
import Label from '@gojob/ui-bits/Label';
import CloseAdornment from '@gojob/ui-bits/PlacesAutocomplete/Adornment';
import useTheme from '@gojob/ui-bits/styles/useTheme';

import Input from 'src/components/Input';
import useTranslation from 'src/translations/useTranslation';

export interface KeywordFieldProps extends Omit<InputProps<'input'>, 'ref'> {
  onClear?: () => void;
}

const KeywordField: FunctionComponent<KeywordFieldProps> = (props) => {
  const { value, onClear, ...other } = props;

  const { spacing } = useTheme();
  const t = useTranslation();

  const ref = useRef<HTMLInputElement | null>(null);

  const handleOnClear = () => {
    onClear?.();
    ref.current?.focus?.();
  };

  const Adornment = () => {
    if (value) {
      return <CloseAdornment css={{ margin: spacing(-2, 0, -2, 0) }} onClick={handleOnClear} />;
    }
    return null;
  };

  return (
    <>
      <Label htmlFor="jobLabel">{t('job_search_label')}</Label>
      <Input
        ref={ref}
        data-hj-whitelist // whitelist this input for hotjar record https://help.hotjar.com/hc/en-us/articles/115015563287-How-to-Whitelist-Elements-and-Keystrokes
        id="jobLabel"
        placeholder={t('job_search_placeholder')}
        value={value}
        Adornment={<Adornment />}
        {...other}
      />
    </>
  );
};

export default KeywordField;
